<div
  id="select-company"
  class="select-company-tree"
  (click)="$event.stopPropagation()"
  (keydown.tab)="$event.stopPropagation()"
>
  <div class="company-menu-header">
    @if (treeService.initialStatus() === 'error') {
      <div id="errorBox" class="alert alert-danger tw-mb-4" role="alert">
        <strong>{{ treeService.initialErrorMessage() }}</strong>
      </div>
    }
    @if (!treeService.hasNoSubcompanies()) {
      <search-filter
        class="tw-w-full"
        [filterConfig]="filterConfig"
        [search]="search"
        [focus]="true"
        [doSearch]="doSearch"
      ></search-filter>
    }
  </div>
  <div class="select-company-tree__body" #treeScrollRoot>
    @if (treeService.initialStatus() === 'loading') {
      <div
        id="select-company-list-spinner"
        class="tw-flex tw-justify-center tw-items-center tw-h-[128px] tw-bg-white/60"
      >
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    }
    @if (
      mode() === 'tree' &&
      treeService.initialStatus() === 'loaded' &&
      !treeService.hasNoSubcompanies()
    ) {
      <company-tree
        [scrollRoot]="treeScrollRoot"
        (selectCompany)="closeMenu.emit()"
      ></company-tree>
    }
  </div>
  <div class="company-menu-footer">
    <a
      mat-button
      uiSref="apps.company.add"
      id="add-subcompany-menu-button"
      (click)="closeMenu.emit()"
    >
      <div class="tw-flex tw-gap-[12px] tw-items-center">
        <mat-icon svgIcon="add" class="small medium"></mat-icon>
        <span>Add Sub-Company</span>
      </div>
    </a>
    <button
      mat-button
      type="button"
      (click)="licenseManagement()"
      id="company-licenses-button"
    >
      <div
        class="tw-flex tw-gap-[12px] tw-items-center tw-justify-between tw-w-full"
      >
        <div class="tw-flex tw-gap-[12px] tw-items-center">
          <mat-icon
            svgIcon="hierarchy"
            class="small medium"
            aria-hidden="true"
          ></mat-icon>
          <span>Companies &amp; Licenses</span>
        </div>
        @if (!companyAccessService.accessCompanyLicenses) {
          <mat-icon
            class="small"
            svgIcon="requires-upgrade"
            id="company-licenses-requires-upgrade"
            aria-hidden="true"
          ></mat-icon>
          <span class="tw-sr-only">Requires upgrade</span>
        }
      </div>
    </button>
  </div>
</div>
